import React from 'react';
import i18n from '../../i18n';
import { AppDataContext } from '../../context/Context';
import Autocomplete from '@mui/material/Autocomplete';
import FormControl from '@mui/material/FormControl';
import { TextField } from '@mui/material';
import { getExtractValue } from '../../utils/formatName';

export default class DialogRoleSelectField extends React.Component {
    static contextType = AppDataContext;

    handleChanged = (field, value) => {
        this.props.onChange(field, value || null);
    };

    render() {
        const { field, value } = this.props;
        const translatedName = i18n.t(`columns.${field.label}`);
        const show = field.show;
        const translate = field.translate || null;

        const nestedObject = field.nestedObject;
        const secondaryObject = field.secondaryObject || null;

        const items = this.context.getState().controllersData[field.from] || [];

        const mappedItems = items.map((item) => {
            const val = getExtractValue(item, show, nestedObject, secondaryObject);
            const translatedValue = translate ? i18n.t(`${translate}.${val}`) : val;
            return {
                ...item,
                _label: translatedValue
            };
        });

        const onlyRead = !!field.onlyRead;

        return (
            <FormControl fullWidth>
                <Autocomplete
                    value={value ? mappedItems.find((item) => item.id === value.id) : null}
                    onChange={(event, newValue) => {
                        this.handleChanged(field.id, newValue);
                    }}
                    options={mappedItems}
                    getOptionLabel={(option) => option._label || ''}
                    isOptionEqualToValue={(option, val) => option.id === val.id}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label={translatedName}
                            variant="outlined"
                        />
                    )}
                    disabled={onlyRead}
                />
            </FormControl>
        );
    }
}
